import { Injectable, Optional } from '@angular/core';
import { IConfig } from '../interfaces/config.interface';

export class ConfigService {

  endPoint: string;
  saveCustomUserState: boolean;

  constructor(@Optional() config: IConfig) {
    if (config) {
      this.endPoint = config.endPoint;
      this.saveCustomUserState = config.saveCustomUserState;
    }
  }
}
